module.exports = __webpack_public_path__ + "img/header-diamondJewelryPresentsValentine.7f07393.webp";